<div mat-dialog-content
	class="cm-ranch-create-step-content">
	<h3 class="cm-ranch-create-step-heading">
		{{ 'Planting Areas' | translate }} ({{ 'Optional' | translate }})
	</h3>

	<p class="cm-ranch-create-step-help">
		Add a planting area to organize your plantings and share soil data across plantings.
	</p>

	<p class="cm-ranch-create-step-optional-help">
		<mat-icon class="cm-ranch-create-step-optional-help__icon material-symbols-outlined">info</mat-icon>
		This can be added later in Ranch Settings.
	</p>

	<button
		class="bk-button bk-create-button cm-ranch-create-add-button"
		(click)="openAddPlantingAreaDialog()">
		<mat-icon class="cm-ranch-create-add-button__icon">add</mat-icon>
		{{'Add Planting Area' | translate }}
	</button>

	<table *ngIf="plantingAreaControls.length > 0"
		class="bk-form__table cm-irrigation-methods-ui__table">
		<colgroup>
			<col span="1" class="cm-irrigation-methods-ui__col1">
			<col span="1" class="cm-irrigation-methods-ui__col2">
			<col span="1" class="cm-irrigation-methods-ui__col4">
		</colgroup>
		<thead>
			<th>
				{{ 'Name' | translate }}
			</th>
			<th class="cm-tcell--align-right">
				{{ 'Acres' | translate }}
			</th>
			<th>
				{{ 'Action' | translate }}
			</th>
		</thead>
		<tbody>
			<tr *ngFor="let plantingArea of plantingAreaControls; let i = index"
				class="cm-table-row--padded"
				(click)="openEditPlantingAreaDialog(i, $event)">
				<td>
					{{ plantingArea.get('Name').value }}
				</td>
				<td class="cm-tcell--align-right">
					{{ plantingArea.get('Acres').value }}
				</td>
				<td class="cm-irrigation-methods-ui__action">
					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						(click)="openEditPlantingAreaDialog(i, $event)">
						<mat-icon matTooltip="{{ 'Edit' | translate }}">edit</mat-icon>
					</button>

					<button type="button"
						class="cm-irrigation-methods-ui__action__button cm-irrigation-methods-ui__action__button--primary"
						(click)="deletePlantingArea(i, $event)">
						<mat-icon matTooltip="{{ 'Delete' | translate }}">delete</mat-icon>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<div mat-dialog-actions
	align="end">
	<button class="bk-button__delete"
		(click)="cancel()">
		{{ 'Cancel' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium bk-button--text-only bk-dialog__button--secondary"
		(click)="back()">
		{{ 'Back' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium"
		[disabled]="isSaving || (form && !form.valid)"
		(click)="finish()">
		{{ (plantingAreaControls.length > 0 ? 'Finish' : 'Skip and finish') | translate }}
	</button>
</div>
